module.exports = __webpack_public_path__ + "img/cru.5c50ad6.webp";